/* eslint-disable object-curly-newline */
/* eslint-disable */
import React from 'react';
import { useSelector } from 'react-redux';

import {
  fieldShouldDisplay,
  getOptions,
  handleChange,
  isRequired,
  getFieldKey,
  handleValidation,
} from '../../../../utils/form';

import FormLabel from './FormLabel';

function Options({ opts, onChange, valuesArray, submittedFlag, name }) {
  return (
    <>
      {opts.map(option => (
        <div key={option.value} className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            defaultChecked={option.defaultChecked}
            checked={valuesArray.includes(option.value)}
            id={option.value}
            onChange={(e) => onChange(e, option)}
            disabled={option.disabled || submittedFlag}
          />
          <FormLabel className="form-check-label" name={option.value} label={option.label} />
        </div>
      ))}
    </>
  );  
}

function CategorizedOptions({ opts, cats, onChange, valuesArray, submittedFlag, name }) {
  return (
    <>
      {cats.map(category => {
        return (
          <>
            <div key={category} className="mb-2">
              {category}:
            </div>
            {opts.filter(option => option.category === category).map(option => (
              <div key={option.value} className="form-check mx-5">
                <input
                  type="checkbox"
                  className="form-check-input"
                  defaultChecked={option.defaultChecked}
                  checked={valuesArray.includes(option.value)}
                  id={option.value}
                  onChange={(e) => onChange(e, option)}
                  disabled={option.disabled || submittedFlag}
                />
                <FormLabel className="form-check-label" name={option.value} label={option.label} />
              </div>
            ))}
          </>
        )})}
      {opts.filter(option => !option.category).map(option => (
        <div key={option.value} className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            defaultChecked={option.defaultChecked}
            checked={valuesArray.includes(option.value)}
            id={option.value}
            onChange={(e) => onChange(e, option)}
            disabled={option.disabled || submittedFlag}
          />
          <FormLabel className="form-check-label" name={option.value} label={option.label} />
        </div>
            ))}
    </>
  );  
}

function MultiCheck({
  name,
  options = [], // this prop will be overidden if options are specified in form JSON config
  unsetOthersOnSelected = [],
  boldLabel = false,
}) {

  const { values, form: { form } } = useSelector(store => store);
  const valuesArray = values[name] || [];
  const required = isRequired({ form, name, currentValues: values });
  const customLabel = getFieldKey(form, name, 'label');
  const validationRegex = useSelector(store => store.validation[name]);
  const defaultLabel = useSelector(store => store.labels[name]);
  const { submittedFlag } = useSelector(store => store.enrollment);

  // defaults to what is being passed in by prop `options`,
  //  can be overidden by setting options in form JSON config
  let opts = getOptions(form, name);
  if (!opts) opts = options;

  // an opt can provide a category prop which will categorize options underneath said cat
  let cats = [];
  if (opts.filter(opt => opt.category).length) {
    cats = [...(new Set(opts.reduce((acc, opt) => opt.category ? [...acc, opt.category] : acc, [])))];
  }

  function updateValues(value, checked, vArray) {
    // if we have an unsetOthersOnSelected prop then we want to unselect
    // all other values if it gets selected
    if (unsetOthersOnSelected.includes(value) && checked === true) {
      const rval = [ value ];
      handleValidation({ valuesArray: rval, validationRegex, name, required });
      return rval;

    // if we have an unsetOthersOnSelected prop then when any OTHER value
    // is selected we want to UNSELECT this value
    } if (unsetOthersOnSelected && !unsetOthersOnSelected.includes(value) && checked === true) {
      const rval = [...vArray, value].filter(val => !unsetOthersOnSelected.includes(val));
      handleValidation({ valuesArray: rval, validationRegex, name, required });
      return rval

    // if value is checked, add it to the vArray
    } if (checked === true) {
      const rval = [...vArray, value];
      handleValidation({ valuesArray: rval, validationRegex, name, required });
      return rval;

    // if value is unchecked, remove it from vArray
    } if (checked === false) {
      let rval = [...vArray].filter(val => val !== value);
      // if removing last value from the array, set field to undefined
      if (rval.length === 0) rval = undefined;
      handleValidation({ valuesArray: rval, validationRegex, name, required });
      return rval;
    }

    handleValidation({ valuesArray: vArray, validationRegex, name, required });
    return [...vArray];
  }

  // if field doesn't exist or is conditionally hidden, don't show it.
  if (!fieldShouldDisplay(form, name, values)) return null;

  function onBlur(e, option) {
    handleValidation({ valuesArray, validationRegex, name, required });
  }

  function onChange(e, option) {
    handleChange({
      value: updateValues(option.value, e.target.checked, valuesArray),
      name,
      required,
    });
  }

  return (
    <>
      <FormLabel
        name={name}
        label={customLabel || defaultLabel}
        required={required}
        className={['mb-3', (boldLabel ? 'fw-bold' : '')].join(' ')}
      />
      {!cats.length
         ? (
           <Options
             opts={opts}
             valuesArray={valuesArray}
             onChange={onChange}
             onBlur={onBlur}
             submittedFlag={submittedFlag}
             name={name}
           />
         ) : (
           <CategorizedOptions
             opts={opts}
             cats={cats}
             valuesArray={valuesArray}
             onChange={onChange}
             onBlur={onBlur}
             submittedFlag={submittedFlag}
             name={name}
           />
         )}
    </>
  );
}

export default MultiCheck;
